import { makePrefixer } from "@jpmorganchase/uitk-core";

export const withBaseName = makePrefixer("uitkPagination");
